import { attributeDefinitionIdFormat } from "@redotech/redo-model/ids";

import { AttributeType, OwnerType } from "@redotech/redo-prisma-client/enums";
import * as z from "zod/v4";

export const createAttributeDefinition = {
  name: "createAttributeDefinition" as const,
  input: z.object({
    ownerType: z.enum(OwnerType),
    name: z.string().min(1),
    displayName: z.string().min(1),
    description: z.string().optional(),
    type: z.enum(AttributeType),
    enumValues: z.array(z.string()).optional(),
    defaultValue: z.json().optional(),
  }),

  output: z.object({
    attributeDefinitionId: attributeDefinitionIdFormat.schema,
  }),
};
